import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const TransactionAirdropped = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.1665 9.5V9.70709L12.063 18.6035L10.5452 20.1213L12.6665 22.2426L14.7878 20.1213L13.27 18.6036L22.0129 9.86078L22.1665 9.72058V9.48792C22.1599 5.96869 19.2568 3.13617 15.6665 3.00476V3H9.6665V3.00476C6.07202 3.13635 3.1665 5.97522 3.1665 9.5ZM4.17041 9.29675L6.19604 11.3224L8.64917 9.26324C8.72681 7.16797 9.83228 5.33594 11.4866 4.20331C10.9915 4.07092 10.4685 4 9.92749 4C6.79761 4 4.28223 6.37164 4.17041 9.29675ZM18.3289 12.1306L18.0584 11.8838L15.6882 9.61519C15.684 9.51484 15.6823 9.40215 15.6836 9.27582C15.7007 7.55164 14.4065 5.55939 12.6665 4.65961C10.9265 5.55939 9.63232 7.55164 9.64941 9.27582C9.65093 9.42833 9.64808 9.56085 9.64165 9.6757L6.90576 12.0322L12.6665 17.7929L18.3289 12.1306Z"
      fill="currentColor"
    />
  </svg>,
  'TransactionAirdroped'
);
